<template>
  <div class="row py-2">
    <div class="col-10 text-left">
      <h5 class="font-weight-bold">Standby Crews</h5>
    </div>
    <div class="col-2 text-center d-flex justify-content-end align-items-center">
      <button class="btn btn-primary btn-xs p-1 d-flex align-items-center"
              :disabled="params.manning_id === null && params.rank_id === null"
              v-if="!isLoading"
              @click="downloadStandbyVaccinated">
        <i class="fas fa-file-pdf fa-2x mx-1"></i>
        Generate Report
      </button>
    </div>
    <div class="col-6 text-left">
      <div class="form-inline d-flex justify-content-start w-100">
        <div class="form-group py-1 mx-3" v-if="isPrincipal">
          <label for="manning" class="form-control-xs font-weight-bold">Select Manning: </label>
          <select name="manning" id="manning" class="form-control form-control-xs mx-2"
                  v-model="params.manning_id" :disabled="isLoading">
            <option :value="null" id="manningOption0" disabled selected>---Select Manning ---</option>
            <option value="">ALL MANNING</option>
            <option v-for="manningKey in getManningLists"
                    :key="manningKey.id"
                    :title="manningKey.name"
                    :value="manningKey.id">
              {{ manningKey.alias }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-6 text-center d-flex justify-content-end align-items-center">
      <nav aria-label="...">
        <ul class="pagination text-smallest mb-0 pb-0">
          <li
              class="page-item"
              :class="{ disabled: pagination.currentPage === 1 }"
          >
            <button class="page-link" @click="setPage(1)">First</button>
          </li>

          <li
              v-for="page in paginationPages"
              :key="page"
              class="page-item"
              :class="{
                disabled: page === '...',
                active: page === pagination.currentPage,
              }"
          >
            <button class="page-link" @click="setPage(page)">
              {{ page }}
            </button>
          </li>

          <li
              class="page-item"
              :class="{
                disabled: pagination.currentPage === pagination.lastPage,
              }"
          >
            <button class="page-link" @click="setPage(pagination.lastPage)">
              Last
            </button>
          </li>
        </ul>
      </nav>
      <small class="mx-3">{{
          `${pagination.from} to ${pagination.to} of ${pagination.total}`
        }}</small>
    </div>
    <div class="col-lg-4 col-md-4 col-xl-4 col-sm-12">
      <div class="form-inline d-flex justify-content-start w-100">
        <div class="form-group form-inline py-1 mx-3">
          <label for="rank" class="form-control-xs font-weight-bold">Select Rank: </label>
          <select name="rank" id="rank" class="form-control form-control-xs mx-2"
                  v-model="params.rank_id" :disabled="isLoading">
            <option :value="null" id="rankOption0" disabled selected>---Select Ranks ---</option>
            <option value="">ALL RANKS</option>
            <option v-for="rankKey in rankKeys"
                    :key="rankKey.id"
                    :value="rankKey.id"
                    :title="rankKey.name"
            >{{ rankKey.alias }}
            </option>
          </select>
        </div>
      </div>

    </div>
    <div class="col-lg-4 col-md-4 col-xl-4 col-sm-12">
      <div class="form-inline d-flex justify-content-start w-100">
      <div class="form-group py-1 mx-3">
        <label for="rank" class="form-control-xs font-weight-bold">Vaccination Status: </label>
        <select name="rank" id="rank" class="form-control form-control-xs mx-2"
                v-model="params.is_booster" :disabled="isLoading">
          <option :value="null">ALL</option>
          <option :value="0">FULLY VACCINATED</option>
          <option :value="1">WITH BOOSTER SHOTS</option>
        </select>
      </div>
      </div>
    </div>
    <div class="col col-12">
      <div class=" table-responsive my-2">
        <table class="table table-hover table-bordered table-template-1 text-small table-striped">
          <thead>
          <tr>
            <th>No</th>
            <th>Rank</th>
            <th>Name</th>
            <th>Manning</th>
            <th>Brand</th>
            <th>Completion Date</th>
            <th>Administering Country</th>
          </tr>
          </thead>

          <tbody class="text-small">
          <tr v-if="isLoading">
            <td colspan="100%">
              <app-loading></app-loading>
            </td>
          </tr>
          <template v-else>
            <tr v-for="(crew, index) in standbyCovidVaccinated.data" :key="crew.id">
              <td class="text-center">{{ index + 1}}</td>
              <td class="text-center">{{crew.rank}}</td>
              <td class="text-left">
                <router-link :to="{name:'CrewActivity',params:{id:crew.id}}" target="_blank"
                             v-if="crew.name" class="mb-0">{{ crew.name }}
                </router-link>
              </td>
              <td class="text-center">{{crew.manning}}</td>
              <td class="text-center">{{crew.brand}}</td>
              <td class="text-center" v-if="crew.vaccine_brand_id === 7">{{crew.inoculateDate}}</td>
              <td class="text-center" v-else>{{crew.completionDate}}</td>
              <td class="text-center" >{{crew.adminCountry}}</td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <download-pdf-loading></download-pdf-loading>
  </div>
</template>

<script>
import {vueAppMixin} from '../../../../mixins/vueAppMixin';
import {gateMixin} from '../../../../mixins/gateMixin';
import AppLoading from '../../../elements/AppLoading';
import {mapActions, mapGetters} from 'vuex';
import DownloadPDFLoading from '../../../elements/DownloadPDFLoading';
import {DateService} from '../../../../services/Utilities/DateService';
import {ReportService} from '../../../../services/ReportService';

export default {
  name: 'GenerateStandbyVaccinatedCrew',
  mixins: [vueAppMixin, gateMixin],
  components: {
    AppLoading,
    'download-pdf-loading': DownloadPDFLoading
  },
  data() {
    return {
      params: {
        date_from: DateService.dateToday(),
        date_to: DateService.dateToday(),
        manning_id: null,
        rank_id: null,
        is_booster: null,
        page: 0
      },
      modalLoad: false
    };
  },
  methods: {
    ...mapActions([
      'getRankKeys',
      'getManningKeys',
      'getStandbyCovidVaccinated',
      'generateStandbyCovidVaccinatedFile',
      'setLoading',
    ]),

    async downloadStandbyVaccinated() {
      this.modalLoad = true
      document.getElementById('LoadingModal').style.display = 'block'
      !this.params.manning_id ? this.params.manning_id = '' : this.params.manning_id;
      !this.params.rank_id ? this.params.rank_id = '' : this.params.rank_id;
      await ReportService.generateStandbyCovidVaccinatedFile(this.params);
      this.modalLoad = false
      document.getElementById('LoadingModal').style.display = 'none'
    },

    filterStandbyCovidVaccinated(){
      this.params.page = this.pagination.currentPage;
      this.getStandbyCovidVaccinated(this.params);
    },

    async setPage(page) {
      this.pagination.currentPage = page;
      await this.filterStandbyCovidVaccinated();
    }
  },
  computed: {
    ...mapGetters([
      'rankKeys',
      'manningKeys',
      'standbyCovidVaccinated',
      'pagination',
    ]),

    paginationPages() {
      let pages = [];
      let currentPage = this.pagination.currentPage;
      let lastPage = this.pagination.lastPage;
      if (lastPage > 1) {
        let initialLimit = 1;
        if (currentPage + 5 > lastPage) {
          initialLimit = lastPage - 10;
        } else if (currentPage > 6) {
          initialLimit = currentPage - 5;
        }
        initialLimit = initialLimit < 1 ? 1 : initialLimit;
        for (let i = initialLimit; i <= initialLimit + 10; i++) {
          pages.push(i);
          if (i >= lastPage) {
            break;
          }
        }
      }
      return pages;
    },
    getManningLists(){
      return this.manningKeys.filter((manning)=>{
        return this.isKline ? ![7,17].includes(manning.id) : true
      })
    }
  },
  created(){
    this.getRankKeys();
    this.getManningKeys();
    this.setLoading(false);
  },
  watch: {
    'params.manning_id'() {
      this.getStandbyCovidVaccinated(this.params);
      this.pagination.currentPage = 0;
      document.getElementById('manningOption0').style.display = 'none'
    },
    'params.rank_id'() {
      this.getStandbyCovidVaccinated(this.params);
      this.pagination.currentPage = 0;
      document.getElementById('rankOption0').style.display = 'none'
    },
    'params.page'() {
      this.getStandbyCovidVaccinated(this.params);
      this.pagination.currentPage = 0;
    },
    'params.is_booster'() {
      this.getStandbyCovidVaccinated(this.params);
      this.pagination.currentPage = 0;
    }
  },
};
</script>

<style scoped>

</style>
